<template>
  <div class="animated fadeIn">
    <div class="card-group" >
        <b-card class="card mr-1 col-md-3 pl-0 pr-0 ml-0 h-100" style="min-width:412px; min-height: 85vh;">
          <!--SEARCH-->
          <div slot="header" style="background-color: #F0F3F5 !important; ">
            <b-row class="d-flex" style="height: 30px; !important;">
              <div class="ml-3 mr-1 mt-1 mb-1">
            <span style="font-weight: bold;">Search Criteria</span>
            </div>
            </b-row>
          </div>

          <b-row>
            <b-col md="12">

              <b-input-group>
                <DxTextBox
                  placeholder="Enter a Zip Code"
                  id="inputZipCode"
                  class="max-width card-dropdown"
                  ref="inputZipCodeRef"
                  v-model="state.zipCode"
                  aria-describedby="inputZipCode"
                  lazy-formatter
                  value-change-event="keyup"
                  @change="onZipCodeChanged"
                />
              </b-input-group>

              <DxSelectBox
                v-if="state.searchedRegions"
                :disabled="!state.searchedRegions || state.searchedRegions.length <= 1"
                class="mt-2 max-width card-dropdown"
                :data-source="state.searchedRegions"
                display-expr="RegionName"
                value-expr="id"
                :search-enabled="true"
                :value.sync="state.selectedRegionId"
                placeholder="In City"
                @value-changed="onRegionChanged()"
              />

              <DxSelectBox
                v-if="state.selectedRegionCountyId"
                :disabled="true"
                class="mt-2 max-width card-dropdown"
                :data-source="defaults.regions"
                display-expr="name"
                value-expr="id"
                :search-enabled="true"
                :value.sync="state.selectedRegionCountyId"
                placeholder="County"
              />

              <div v-if="state.resultsType === ResultsType.DMV">

                <DxSelectBox
                  class="mt-2 max-width card-dropdown"
                  :data-source="defaults.stockType"
                  display-expr="name"
                  value-expr="id"
                  :search-enabled="true"
                  :value.sync="state.selectedStockType"
                  placeholder="Stock Type"
                  @value-changed="onVehicleFilterChanged()"
                />

                <DxSelectBox
                  v-if="defaults.models"
                  class="mt-2 max-width card-dropdown"
                  :data-source="defaults.years"
                  :search-enabled="true"
                  :value.sync="state.selectedYear"
                  placeholder="Year"
                  @value-changed="onVehicleFilterChanged()"
                />

                <DxSelectBox
                  v-if="defaults.models"
                  class="mt-2 max-width card-dropdown"
                  :data-source="defaults.makes"
                  display-expr="Name"
                  value-expr="ID"
                  :search-enabled="true"
                  :value.sync="state.selectedMakeId"
                  placeholder="Make"
                  @value-changed="onVehicleFilterChanged()"
                />

                <DxSelectBox
                  v-if="defaults.models"
                  class="mt-2 max-width card-dropdown"
                  :data-source="defaults.models"
                  display-expr="Name"
                  value-expr="ID"
                  :search-enabled="true"
                  :value.sync="state.selectedModelId"
                  placeholder="Model"
                  @value-changed="onVehicleFilterChanged()"
                />

                <DxSelectBox
                  v-if="defaults.vehicles"
                  class="mt-2 max-width card-dropdown"
                  :data-source="vehiclesGrouped"
                  :search-enabled="true"
                  :grouped="true"
                  display-expr="ShortDescriptionModel"
                  value-expr="ID"
                  :value.sync="state.selectedVehicleId"
                  placeholder="Trim"
                  @value-changed="onVehicleFilterChanged()"
                />

              </div>
            </b-col>

          </b-row>
          <b-row>

            <div class="ml-auto mt-2 mr-3 pt-1 pb-1">
              <strong>
              <a href="#" @click="restoreDefaults" class="pull-right" style="color: #004173;">
                (Clear Criteria)
              </a>
              </strong>
            </div>
            <!-- This needs to be here to trigger auto scroll -->
            <div style="display: hidden; height: 50px;">
            </div>
          </b-row>
        </b-card>

      <b-card md="4" class="card ml-0 pr-0 pl-0" style="min-width:470px" v-if="state.resultsType === ResultsType.DMV">
          <div slot="header">
            <b-row style="height:30px;">
              <b-col>
                <div class="mr-1 mt-1 mb-1">
                <span style="font-weight: bold;">
                  DMV Registration
                </span>
                </div>
              </b-col>
            </b-row>
          </div>
            <b-row>
              <b-col md="12">

                <b-input-group v-if="state.parameters" >
                  <div class="max-width" v-for="t in parametersGrouped">
                    <h6><b><strong>{{ getModeName(t.ModeType) }}</strong></b></h6>

                    <div class="max-width center-content" v-for="s in t.Parameters">

                      <b-col md="7" class="mt-2 no-padding-left">
                          {{ getPropertyDescription(s.Description) }}
                          <span v-if="s.Requirement === RequirementType.Required"><b>- Required</b></span>
                      </b-col>
                      <b-col md="5" class="mt-2 no-padding-right">

                        <DxNumberBox
                          class="max-width card-dropdown"
                          v-model="s.Value"
                          value="0"
                          aria-describedby="inputParameter"
                          format="$ #,##0.##"
                          v-if="s.RequestPath === 'DesiredValue' ||
                            s.RequestPath === 'Vehicle.TotalMSRP' ||
                            s.RequestPath === 'Vehicle.BaseMSRP' ||
                            s.RequestPath === 'Vehicle.TotalDealerCost'"
                          lazy-formatter
                        />

                        <DxNumberBox
                          class="max-width"
                          v-model="s.Value"
                          aria-describedby="inputParameter"
                          value="0"
                          format="#0.## lb"
                          v-if="s.RequestPath === 'Vehicle.Weight'"
                          lazy-formatter
                        />

                        <DxNumberBox
                          class="max-width"
                          v-model="s.Value"
                          aria-describedby="inputParameter"
                          value="0"
                          format="#0.## lb"
                          v-if="s.RequestPath === 'Vehicle.GrossVehicleWeightRating'"
                          lazy-formatter
                        />

                        <DxNumberBox
                          class="max-width"
                          v-model="s.Value"
                          format="#"
                          value="0"
                          aria-describedby="inputParameter"
                          v-if="s.RequestPath !== 'Vehicle.Weight' &&
                            s.RequestPath !== 'Vehicle.GrossVehicleWeightRating' &&
                            s.RequestPath !== 'DesiredValue' &&
                            s.RequestPath !== 'Vehicle.TotalMSRP' &&
                            s.RequestPath !== 'Vehicle.BaseMSRP' &&
                            s.RequestPath !== 'Vehicle.TotalDealerCost' &&
                            s.ValueType === ValueType.Integer"
                          lazy-formatter
                        />

                        <DxNumberBox
                          class="max-width"
                          v-model="s.Value"
                          format="#.##"
                          value="0"
                          aria-describedby="inputParameter"
                          v-if="s.RequestPath !== 'Vehicle.Weight' &&
                            s.RequestPath !== 'Vehicle.GrossVehicleWeightRating' &&
                            s.RequestPath !== 'DesiredValue' &&
                            s.RequestPath !== 'Vehicle.TotalMSRP' &&
                            s.RequestPath !== 'Vehicle.BaseMSRP' &&
                            s.RequestPath !== 'Vehicle.TotalDealerCost' &&
                            s.ValueType === ValueType.Decimal"
                          lazy-formatter
                        />

                        <DxSwitch
                          v-model="s.Value"
                          :value="s.Value"
                          v-if="s.ValueType === ValueType.Boolean"
                          class="pull-right"
                          ref="inputParameterRef"
                          aria-describedby="inputParameter"
                          lazy-formatter
                        />

                        <DxTextBox
                          class="max-width"
                          v-model="s.Value"
                          aria-describedby="inputParameter"
                          v-if="s.ValueType === ValueType.String"
                          ref="inputParameterRef"
                          lazy-formatter
                        />

                        <DxDateBox
                          class="max-width"
                          v-model="s.Value"
                          :value="s.Value"
                          type="date"
                          v-if="s.ValueType === ValueType.Date"
                          aria-describedby="inputParameter"
                          ref="inputParameterRef"
                          lazy-formatter
                        />

                      </b-col>
                    </div>

                  </div>

                </b-input-group>

                <div v-if="isShowingResultsButton">

                <hr />

                  <button
                    class="btn btn-primary text-white pull-right mt-2 btn-calculate"
                    @click="getRegistrationFees()"
                    v-shortkey="['alt', 'e']">
                    <span v-if="state.getResultsLoading">
                      <i title="Get Results" class="fa fa-circle-o-notch fa-spin mr-2"></i>
                      <span>Loading...</span>
                    </span>
                    <span v-else>
                      <i title="Get Results" class="fa fa-car fa-lg mr-2"></i>
                      <span>Get Results</span>
                    </span>
                  </button>

                </div>

              </b-col>
            </b-row>
      </b-card>

      <b-card md="5" class="card pl-0 pr-0 ml-1" style="min-width:470px" v-if="state.resultsType === ResultsType.DMV">
        <!--Results -->
          <div slot="header">
            <b-row style="height:30px;">
              <b-col>
                <div class="mr-1 mt-1">
                <span style="font-weight: bold;">
                  Results
                </span>
                </div>
              </b-col>
              <b-col>
                <div class="mr-1 mt-1">
              <button class="btn btn-primary text-white pull-right"
                      @click="toggleResultsType(ResultsType.DMV)"
                      v-shortkey="['alt', 'f']">
                  <i title="DMV" class="fa fa-car mr-2"></i>
                  <span>DMV</span>
              </button>

               <button class="btn btn-outline-primary pull-right"
                      @click="toggleResultsType(ResultsType.TaxRates)"
                      v-shortkey="['alt', 'g']">
                  <i title="Tax Rates" class="fa fa-dollar mr-2"></i>
                  <span>Tax Rates</span>
              </button>
                </div>
              </b-col>
            </b-row>

          </div>

          <b-row>
            <b-tabs class="max-width ml-3" fill>
              <b-tab title="Result" active>
                <div v-if="!response">Waiting for Calculation Results ...</div>
                <div v-if="areLeaseAndRetailFeesTheSame">
                  <div v-if="this.response && this.response.Lease && this.response.Retail">
                    <h5><b><strong>Retail and Lease:</strong></b></h5>
                    <div v-for="t in this.response.Lease.RegistrationItem">
                      <b-row>
                        <b-col md="9">
                          {{ t.Description }}:
                        </b-col>
                        <b-col md="3">
                          <money-format :value="t.Value"></money-format>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col md="9">
                        <b>Total:</b>
                      </b-col>
                      <b-col md="3">
                        <b><strong><money-format :value="this.response.Lease.Value"></money-format></strong></b>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-if="!areLeaseAndRetailFeesTheSame">
                  <div v-if="this.response && this.response.Lease && this.response.Retail">
                    <h5><b><strong>Lease:</strong></b></h5>
                    <div v-for="t in this.response.Lease.RegistrationItem">
                      <b-row>
                        <b-col md="9">
                          {{ t.Description }}:
                        </b-col>
                        <b-col md="3">
                          <money-format :value="t.Value"></money-format>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col md="9">
                        <b>Total:</b>
                      </b-col>
                      <b-col md="3">
                        <b><strong><money-format :value="this.response.Lease.Value"></money-format></strong></b>
                      </b-col>
                    </b-row>
                    <hr />
                    <h5><b><strong>Retail</strong></b></h5>
                    <div v-for="t in this.response.Retail.RegistrationItem">
                      <b-row>
                        <b-col md="9">
                          {{ t.Description }}:
                        </b-col>
                        <b-col md="3">
                          <money-format :value="t.Value"></money-format>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col md="9">
                        <b>Total:</b>
                      </b-col>
                      <b-col md="3">
                        <b><strong><money-format :value="this.response.Retail.Value"></money-format></strong></b>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-tab>
              <b-tab title="JSON Request">

                <editor :value="showJsonRequest" @init="editorInit" height="500" theme="chrome"></editor>

              </b-tab>
              <b-tab title="JSON Response">
                <editor :value="showJsonResponse" @init="editorInit" height="500" theme="chrome"></editor>
              </b-tab>
            </b-tabs>
          </b-row>
      </b-card>

      <b-card md="6" class="card p-0" v-if="state.resultsType === ResultsType.TaxRates">
        <!--Results -->
          <div slot="header">
            <b-row>
              <b-col>
                <span style="font-weight: bold;">
                  Results
                </span>
              </b-col>

              <button class="btn btn-outline-primary pull-right"
                      @click="toggleResultsType(ResultsType.DMV)"
                      v-shortkey="['alt', 'f']">
                  <i title="DMV" class="fa fa-car mr-2"></i>
                  <span>DMV</span>
              </button>

               <button class="btn btn-primary pull-right"
                      @click="toggleResultsType(ResultsType.TaxRates)"
                      v-shortkey="['alt', 'g']">
                  <i title="Tax Rates" class="fa fa-dollar mr-2"></i>
                  <span>Tax Rates</span>
              </button>

            </b-row>

          </div>

          <b-row>
            <b-tabs class="max-width ml-3" fill>
              <b-tab title="Result" active>
                <div v-if="!responseTax">Waiting for Location Selection ...</div>
                <div v-if="this.responseTax && this.responseTax.StateFeeTax && this.responseTax.marketFeeProperties">
                  <h5><b><strong>State Tax Rates:</strong></b></h5>
                  <b-row>
                    <b-col md="6">
                      Region Id
                    </b-col>
                    <b-col md="6" class="text-right">
                      {{ this.responseTax.RegionID }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      Region Name
                    </b-col>
                    <b-col md="6" class="text-right">
                      {{ this.responseTax.RegionName }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      Location
                    </b-col>
                    <b-col md="6" class="text-right">
                      {{ this.state.selectedRegionCounty.name }}
                    </b-col>
                  </b-row>
                  <b-row v-if="this.responseTax.InCity">
                    <b-col md="6">
                      In City
                    </b-col>
                    <b-col md="6" class="text-right">
                      {{ this.responseTax.InCity }}
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col md="12">
                      <h6>State Fee Tax</h6>
                      <b-row v-for="s in getFilteredFields(this.responseTax.StateFeeTax)">
                        <template v-if="getFilteredFields(s.Value).length === 0">
                        <b-col md="3">
                          {{ getPropertyDescription(s.Name) }}
                        </b-col>
                        <b-col md="9" class="text-right">
                          <div>
                            {{ getTaxRateValue(s) }}
                          </div>
                        </b-col>
                        </template>
                        <template v-if="getFilteredFields(s.Value).length > 0">
                        <b-col md="3">
                          {{ getPropertyDescription(s.Name) }}
                        </b-col>
                        <b-col md="9">
                          <div>
                            <b-row v-for="obj in getFilteredFields(s.Value)">
                              <b-col md="6">
                                {{ getPropertyDescription(obj.Name) }}
                              </b-col>
                              <b-col md="6"  class="text-right" v-if="obj.Value === null || Array.isArray(obj.Value)===false">
                                {{ getTaxRateValue(obj) }}
                              </b-col>
                              <b-col v-else>
                              </b-col>
                              <template v-if="obj.Value !== null && Array.isArray(obj.Value)">
                                <template v-if="obj.Value.length > 0" v-for="arrayOfObj in obj.Value">
                                  <b-col md="6" class="pb-2">
                                  </b-col>
                                  <b-col md="6" class="pb-2">
                                  </b-col>
                                  <template v-if="obj.Value.length > 0" v-for="eachObject in getArrayOfObjectFields(arrayOfObj)">
                                    <b-col md="6" class="pl-5 text-left">
                                      {{getPropertyDescription(eachObject.Name)}}
                                    </b-col>
                                    <b-col md="6" class="text-right">
                                      {{getFormattedValue(eachObject)}}
                                    </b-col>
                                  </template>
                                </template>
                              </template>
                            </b-row>
                          </div>
                        </b-col>
                        </template>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <h6>Market Fees</h6>
                      <MarketFee :properties="this.responseTax.marketFeeProperties" :propertyDescriptions="defaults.propertyDescriptions" />
                    </b-col>
                  </b-row>

                </div>
              </b-tab>
              <b-tab title="JSON Request">
                <editor :value="showJsonTaxRequest" @init="editorInit" height="500" theme="chrome"></editor>
              </b-tab>
              <b-tab title="JSON Response">
                <editor :value="showJsonTaxResponse" @init="editorInit" height="500" theme="chrome"></editor>
              </b-tab>
            </b-tabs>
          </b-row>
          <b-row class="mb-3">
          </b-row>
      </b-card>

    </div>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import { isNullOrUndefined } from 'util'
import moment from 'moment'
import VueShortkey from 'vue-shortkey'
import VueToastr2 from 'vue-toastr-2'
import jQuery from 'jquery'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import { DxSelectBox, DxTextBox, DxNumberBox, DxSwitch, DxDateBox } from 'devextreme-vue'
import DataSource from 'devextreme/data/data_source'
import { MarketFee } from '../components/index'
import MoneyFormat from 'vue-money-format'

// import 'brace/mode/json'
// import 'brace/theme/twilight'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'

import { BasePageMixin } from '../mixin/BasePageMixin'

const ERROR_TYPE_SHOW = 0

const ERROR_TYPE_CONSOLE = 1

const ERROR_TYPE_TOAST = 2

const DEBUG = true // TODO:  change this back to false to deploy to production

window.toastr = require('toastr')

window.jQuery = jQuery

window.$ = jQuery

console.log(window.jQuery('body'))

Vue.use(VueToastr2)

Vue.use(VueShortkey)

function bestCopyEver (src) {
  return Object.assign({}, src)
}

const emptyString = ''

require(['brace/ext/emmet'], function (data) { // this is huge. so require it async is better
  window.emmet = data.emmet
})

export default {
  components: {
    loading,
    cSwitch,
    editor: require('vue2-ace-editor'),
    shortkey: VueShortkey,
    DxSelectBox,
    DxTextBox,
    DxNumberBox,
    DxSwitch,
    DxDateBox,
    MarketFee,
    'money-format': MoneyFormat
  },
  created () {
    // Defined here so they are privately available for the DOM but not reactive
    this.RequirementType = {}
    this.RequirementType.Undefined = 0
    this.RequirementType.Required = 1
    this.RequirementType.Optional = 2

    this.ResultsType = {}
    this.ResultsType.DMV = 0
    this.ResultsType.TaxRates = 1

    this.StockType = {}
    this.StockType.New = 0
    this.StockType.Used = 1

    this.ModeType = {}
    this.ModeType.Lease = 0
    this.ModeType.Retail = 1
    this.ModeType.mPencil = 2

    this.ModeTypeBitwise = {}
    this.ModeTypeBitwise.Lease = 1
    this.ModeTypeBitwise.Retail = 2

    this.ValueType = {}
    this.ValueType.Undefined = 0
    this.ValueType.Integer = 1
    this.ValueType.Decimal = 2
    this.ValueType.Boolean = 3
    this.ValueType.String = 4
    this.ValueType.Date = 5

    this.ParentType = {}
    this.ParentType.Undefined = 0
    this.ParentType.Lease = 1
    this.ParentType.Retail = 2

    this.RoundingStrategyType = {}
    this.RoundingStrategyType.RoundUp = 0
    this.RoundingStrategyType.RoundDown = 1
    this.RoundingStrategyType.Exact = 2

    this.RegFeeElementType = {}
    this.RegFeeElementType.Undefined = 0
    this.RegFeeElementType.CustomerLastName = 1
    this.RegFeeElementType.CustomerDateOfBirth = 2
    this.RegFeeElementType.PreviousRegistrationDate = 3
    this.RegFeeElementType.RegistrationDate = 4
    this.RegFeeElementType.Bore = 5
    this.RegFeeElementType.NumberOfCylinders = 6
    this.RegFeeElementType.CurbWeight = 7
    this.RegFeeElementType.GrossVehicleWeightRating = 8
    this.RegFeeElementType.RegisterAsCommercialAndPassengerVehicle = 9
    this.RegFeeElementType.RegisterAsPassengerVehicle = 10
    this.RegFeeElementType.RegisterElectronically = 11
    this.RegFeeElementType.EnrolledOReGO = 12
    this.RegFeeElementType.CollectRecreationFee = 13
    this.RegFeeElementType.ElectAletrnativeFuelLicensePlate = 14
    this.RegFeeElementType.CertificateOfOrigin = 15
    this.RegFeeElementType.LienWithUCC = 16
    this.RegFeeElementType.InProgramArea = 17
    this.RegFeeElementType.CollectLienFees = 18
    this.RegFeeElementType.TaxDistrictID = 19
    this.RegFeeElementType.Term = 20
    this.RegFeeElementType.FirstRegistrationDate = 21
    this.RegFeeElementType.Price = 22
    this.RegFeeElementType.MSRP = 23
    this.RegFeeElementType.BaseMSRP = 24
    this.RegFeeElementType.EPAAvg = 25

    this.restoreDefaults()
    this.getDefaultValues()
    this.getRegions()
  },
  mounted () {
    // this.getUserFilledData()
  },
  mixins: [
    BasePageMixin
  ],
  data () {
    return {
      request: null,
      requestTax: null,
      response: null,
      responseTax: null,
      state: {
        getResultsLoading: false,
        resultsType: null,
        selectedMakeId: null,
        selectedModelId: null,
        selectedVehicleId: null,
        selectedRegion: null,
        selectedRegionId: null,
        selectedRegionCountyId: null,
        selectedRegionCounty: null,
        selectedStockType: 0,
        selectedYear: null,
        zipCode: null,
        searchedRegions: null,
        parameters: null,
        isFiltering: false
      },
      defaults: {
        years: null,
        makes: null,
        models: null,
        regions: null,
        vehicles: null,
        stockType: [{ id: 0, name: 'New'}, { id: 1, name: 'Used'}],
        propertyDescriptions: []
      },
      boolLoading: false,
      errMsg: null,
      showDismissibleAlert: false,
      dismissibleType: null,
      requestFormatted: {
        Engine: 'MARSE',
        Customer: {
          LastName: null
        },
        DesiredValue: 0,
        Location: {
          CustomerZIP: 0,
          DealershipZIP: 0,
          TaxRegionID: null
        },
        StateFeeTax: {
          CalculateRegistrationFee: true,
          Lease: {
            TaxablePercentageCalcType: 0,
          },
          Retail: {
            MunicipalityTaxCalcType: 0,
          }
        },
        LeasePart: {},
        RetailPart: {},
        Vehicle: {
          ID: 0,
          TotalDealerCost: 0,
          BaseMSRP: 0,
          TotalMSRP: 0
        }
      }
    }
  },
  methods: {
    restoreDefaults () {
      this.getResultsLoading = false
      this.request = undefined
      this.requestTax = undefined
      this.response = undefined
      this.responseTax = undefined
      this.state.parameters = []

      this.state.selectedRegionCountyId = null
      this.state.selectedRegionCounty = null
      this.state.selectedRegionId = null
      this.state.selectedRegion = null
      this.state.searchedRegions = null
      this.state.selectedVehicleId = null
      this.state.selectedModelId = null
      this.state.selectedMakeId = null
      this.state.selectedYear = null
      this.state.selectedStockType = this.StockType.New
      this.state.zipCode = null
      this.state.isFiltering = false

      this.state.resultsType = this.ResultsType.DMV
    },
    onZipCodeChanged (r) {
      this.submitZipSearch(true, undefined)
      this.persist()
    },
    onRegionChanged () {
      // Ensure a region was selected in the dxSelectBox
      if (this.state.selectedRegionId) {
        const selectedRegion = this.state.searchedRegions.find(x => x.id === this.state.selectedRegionId)

        if (selectedRegion) {
          // Search for this region
          this.submitZipSearch(selectedRegion.InCity ? selectedRegion.InCity : false, selectedRegion)
        }
      }
    },
    onVehicleFilterChanged () {
      this.filterVehicles()
    },
    toggleResultsType (resultsType) {
      this.state.resultsType = resultsType
    },
    editorInit: function () {
      require('brace/ext/language_tools')
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/mode/less')
      require('brace/theme/chrome')
    },
    getDefaultValues () {
      var self = this
      let url = '/api/GetDMVFeesDefaults'

      if (this.state.selectedStockType == this.StockType.New) {
        url += '?isNew=true'
      }

      axios.get(url)
        .then(response => {
          self.defaults.makes = response.data.makes
          self.defaults.models = response.data.models
          self.defaults.years = response.data.years
          self.defaults.propertyDescriptions = response.data.propertyDescriptions

          this.getUserFilledData()
          if (self.hasError(response)) {
            self.handleError(response)
          }
        })
        .catch(error => {
          self.handleException('An error occured during your request ')
        })
    },
    getRegions () {
      axios.get('/api/statetax/GetRegions')
        .then(response => {
          this.boolLoading = false
          this.defaults.regions = response.data.regions
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    submitZipSearch (inCity, selectedRegion) {
      // Clear search parameters
      this.state.selectedRegionCountyId = undefined
      this.state.selectedRegionCountObj = undefined
      this.request = undefined
      this.requestTax = undefined
      this.response = undefined
      this.responseTax = undefined
      this.state.parameters = undefined

      if (!selectedRegion) {
        this.state.searchedRegions = undefined
        this.state.selectedRegion = undefined
        this.state.selectedRegionId = undefined
      }

      // Build request
      if (this.state.zipCode) {
        var obj = {}
        obj.incity = inCity
        obj.zip = this.state.zipCode

        this.boolLoading = true
        // Post to backend
        axios.post('/api/statetax/GetTaxRegions', obj)
          .then(response => {
            this.boolLoading = false

            // Assign searchedRegions for dxSelectBox
            this.state.searchedRegions = response.data
            var x = 1
            this.state.searchedRegions.forEach(i => {
              i.id = x
              x++
            })

            // select first region by default
            if (response.data.length > 0 && !selectedRegion) {
              this.state.selectedRegion = response.data[0]
            } else if (selectedRegion) {
              // If a region has been passed as a parameter, assign it.
              this.state.selectedRegion = selectedRegion
            }

            // If a region was selected
            if (this.state.selectedRegion) {
              // Assign the id to update the dxSelectBox and import fees
              this.state.selectedRegionId = this.state.selectedRegion.id
              this.submitImportStateFees()
            } else {
              this.state.selectedRegionId = null
            }

            if (this.state.selectedVehicleId) {
              this.getRegistrationFeesParameters()
            }
          })
          .catch(error => {
            if (error.response.status == 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.dismissibleType = 'danger'
          })
      }
    },
    submitImportStateFees () {
      // Make sure a region is assigned
      if (this.state.selectedRegion) {
        // Create the request
        var obj = {}
        if (this.state.selectedRegion.InCity) { obj.incity = this.state.selectedRegion.InCity }
        obj.regionid = this.state.selectedRegion.RegionID
        obj.zip = this.state.zipCode

        this.requestTax = obj
        this.boolLoading = true
        // Post to server
        axios.post('/api/statetax/GetZipRegionFeeTax', obj)
          .then(response => {
            this.boolLoading = false

            const props = response.data.marketFeeProperties
            for (let i = 0; i < props.length; i++) {
              if (props[i].name === 'CalculateRegistrationFee') {
                props[i].value = true
              }

              if (props[i].__type === 'array') {
                for (let j = 0; j < props[i].value.length; j++) {
                  if (props[i].value[j].name === 'CalculateRegistrationFee') {
                    props[i].value[j].value = true
                  }
                }
              }
            }

            this.state.selectedRegion.marketFeeProperties = props
            this.state.selectedRegionCounty = this.defaults.regions.find(x => x.code == response.data.selectedRegion)
            this.state.selectedRegionCountyId = this.state.selectedRegionCounty.id

            this.responseTax = this.state.selectedRegion
          })
          .catch(error => {
            console.log('error - submitImportStateFees ' + error)
            if (error.response.status == 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.dismissibleType = 'danger'
          })
      }
    },
    getRegistrationFees () {
      // Create the request
      let obj = JSON.parse(JSON.stringify(this.requestFormatted))

      const location = obj.Location
      location.CustomerZIP = this.state.zipCode
      location.DealershipZIP = this.state.zipCode
      location.TaxRegionID = this.state.selectedRegion.RegionID

      const vehicle = obj.Vehicle
      vehicle.ID = this.state.selectedVehicleId
      // State Fees
      let sft = obj.StateFeeTax
      this.state.selectedRegion.marketFeeProperties.forEach(x => {
        if (!sft[x.name]) {
          sft[x.name] = x.value

          if (x.name === 'DocStampRoundingStrategy') {
            sft[x.name] = this.getRoundingStrategy(x.value)
          }
          if (x.name === 'WaiveRegistrationFee') {
            sft[x.name] = false
          }

          if (x.__type == 'array') {
            const wa = {}

            sft[x.name].forEach(t => {
              wa[t.name] = t.value

              if (t.name === 'DocStampRoundingStrategy') {
                wa[t.name] = this.getRoundingStrategy(t.value)
              }
            })

            sft[x.name] = wa
          }
        }
      })
      obj.StateFeeTax = sft

      // Any additional parameters
      this.state.parameters.forEach(x => {
        if (x.RequestPath !== null) {
          let split = x.RequestPath.split('.')
          let formattedValue = x.Value

          if (x.ValueType === this.ValueType.Date) {
            const parsedDate = new Date(parseInt(x.Value))
            formattedValue = parsedDate.toISOString()
          }

          if (split.length <= 0) {
            obj[x.RequestPath] = formattedValue
          } else {
            let co = obj
            for (let i = 0; i < split.length - 1; i++) {
              if (!co[split[i]]) {
                co[split[i]] = {}
              }

              co = co[split[i]]
            }
            co[split[split.length - 1]] = formattedValue
          }
        }
      })

      this.request = obj
      this.boolLoading = true
      // Post to server
      axios.post('/api/GetRegistrationFees', obj)
        .then(response => {
          this.boolLoading = false
          this.response = response.data
        })
        .catch(error => {
          console.log('error - GetRegistrationFees ' + error)
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    getRegistrationFeesParameters () {
      // Create the request
      var obj = {}
      obj.Zip = this.state.zipCode
      obj.TaxRegionId = this.state.selectedRegion.RegionID
      obj.VehicleId = this.state.selectedVehicleId

      this.boolLoading = true
      // Post to server
      axios.post('/api/GetRegistrationFeesParameters', obj)
        .then(response => {
          let parameters = []
          if (response.data.Parameter && response.data.Parameter.length > 0) {
            for (let i = 0; i < response.data.Parameter.length; i++) {
              if (response.data.Parameter[i]) {
                const param = response.data.Parameter[i]
                if (param.Parameter && param.Parameter.length > 0) {
                  for (let j = 0; j < param.Parameter.length; j++) {
                    let existingParam = null
                    if (param.Parameter[j].RequestPath !== null) {
                      existingParam = parameters.find(x => x.RequestPath !== null && x.RequestPath.toLowerCase() === param.Parameter[j].RequestPath.toLowerCase())
                    }

                    if (existingParam) {
                      switch (param.Mode) {
                        case this.ModeType.Lease:
                          // Lease
                          existingParam.ModeType += this.ModeTypeBitwise.Lease
                          break
                        case this.ModeType.Retail:
                          // Retail
                          existingParam.ModeType += this.ModeTypeBitwise.Retail
                          break
                        case this.ModeType.mPencil:
                          // Retail + Lease
                          existingParam.ModeType += this.ModeTypeBitwise.Lease + this.ModeTypeBitwise.Retail
                          break
                      }
                    } else {
                      param.Parameter[j].ModeType = this.ModeType.Lease
                      switch (param.Mode) {
                        case this.ModeType.Lease:
                          // Lease
                          param.Parameter[j].ModeType += this.ModeTypeBitwise.Lease
                          break
                        case this.ModeType.Retail:
                          // Retail
                          param.Parameter[j].ModeType += this.ModeTypeBitwise.Retail
                          break
                        case this.ModeType.mPencil:
                          // Retail + Lease
                          param.Parameter[j].ModeType += this.ModeTypeBitwise.Lease + this.ModeTypeBitwise.Retail
                          break
                      }

                      // This assigns the defaults
                      if (param.Parameter[j].ValueType === this.ValueType.Boolean) {
                        param.Parameter[j].Value = false
                      } else if (param.Parameter[j].ValueType === this.ValueType.Date) {
                        param.Parameter[j].Value = Date.now()
                      }

                      const selectedVehicle = this.defaults.vehicles.find(x => x.ID === this.state.selectedVehicleId)
                      switch (param.Parameter[j].ElementType) {
                        case this.RegFeeElementType.Undefined:
                        case this.RegFeeElementType.CustomerLastName:
                        case this.RegFeeElementType.CustomerDateOfBirth:
                          break
                        case this.RegFeeElementType.PreviousRegistrationDate:
                          const d = Date.now()
                          d.setFullYear(d.getFullYear() - 1)
                          param.Parameter[j].Value = d
                          break
                        case this.RegFeeElementType.RegistrationDate:
                          param.Parameter[j].Value = Date.now()
                          break
                        case this.RegFeeElementType.Bore:
                          param.Parameter[j].Value = selectedVehicle.Bore
                          break
                        case this.RegFeeElementType.NumberOfCylinders:
                          param.Parameter[j].Value = selectedVehicle.Cylinders
                          break
                        case this.RegFeeElementType.CurbWeight:
                          param.Parameter[j].Value = selectedVehicle.Weight
                          break
                        case this.RegFeeElementType.GrossVehicleWeightRating:
                          if (selectedVehicle.GrossVehicleWeightRating) {
                            param.Parameter[j].Value = selectedVehicle.GrossVehicleWeightRating
                          }
                          break
                        case this.RegFeeElementType.RegisterAsCommercialAndPassengerVehicle:
                        case this.RegFeeElementType.RegisterAsPassengerVehicle:
                        case this.RegFeeElementType.RegisterElectronically:
                        case this.RegFeeElementType.EnrolledOReGO:
                        case this.RegFeeElementType.CollectRecreationFee:
                        case this.RegFeeElementType.ElectAletrnativeFuelLicensePlate:
                        case this.RegFeeElementType.CertificateOfOrigin:
                        case this.RegFeeElementType.LienWithUCC:
                        case this.RegFeeElementType.InProgramArea:
                        case this.RegFeeElementType.CollectLienFees:
                        case this.RegFeeElementType.TaxDistrictID:
                        case this.RegFeeElementType.Term:
                        case this.RegFeeElementType.FirstRegistrationDate:
                          break
                        case this.RegFeeElementType.Price:
                        case this.RegFeeElementType.MSRP:
                          param.Parameter[j].Value = selectedVehicle.MSRP + selectedVehicle.Shipping

                          if (selectedVehicle.GasGuzzlerValueField) {
                            param.Parameter[j].Value += selectedVehicle.GasGuzzlerValueField
                          }
                          break
                        case this.RegFeeElementType.BaseMSRP:
                          param.Parameter[j].Value = selectedVehicle.MSRP
                          break
                        case this.RegFeeElementType.EPAAvg:
                          param.Parameter[j].Value = selectedVehicle.EPAMPGAvg
                          break
                      }

                      parameters.push(param.Parameter[j])
                    }
                  }
                }
              }
            }
          }
          this.state.parameters = parameters.sort(function (a, b) { return b.ModeType - a.ModeType })
          this.boolLoading = false
        })
        .catch(error => {
          console.log('error - GetRegistrationFeesParameters ' + error)
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    HasValue(obj) {
      return obj !== null && obj !== undefined
    },
    getPropertyDescription (name) {
      const pd = this.defaults.propertyDescriptions.find(x => x.Name === name)
      if (pd) {
        return pd.Description
      } else {
        return name
      }
    },
    getArrayOfObjectFields (object) {
      const array = []
      const objectKeys = Object.keys(object)
      const objectValues = Object.values(object)
      for (let i = 0; i < objectKeys.length; i++) {
        const no = { Name: objectKeys[i], Value: objectValues[i] }
        array.push(no)
      }

      return array
    },
    getModeName (modeType) {
      switch (modeType) {
        case 0:
          return 'Undefined'
        case 1:
          return 'Lease'
        case 2:
          return 'Retail'
        case 3:
          return 'Retail and Lease'
      }
    },
    getModeTypeOrder (modeType) {
      switch (modeType) {
        case 0:
          return 0
        case 1:
          return 3
        case 2:
          return 2
        case 3:
          return 1
      }
    },
    getParentType (parentType) {
      switch (parentType) {
        case 0:
          return 'Undefined'
        case 1:
          return 'Lease'
        case 2:
          return 'Retail'
        case 3:
          return 'Retail and Lease'
      }
    },
    getParentTypeOrder (parentType) {
      switch (parentType) {
        case 0:
          return 0
        case 3:
          return 1
        case 2:
          return 2
        case 1:
          return 3
      }
    },
    getRoundingStrategy (roundingStrategy) {
      switch (roundingStrategy) {
        case 'RoundUp':
          return this.RoundingStrategyType.RoundUp
        case 'RoundDown':
          return this.RoundingStrategyType.RoundDown
        case 'Exact':
          return this.RoundingStrategyType.RoundExact
      }
    },
    getTaxRateValue (marketProperty) {
      if (marketProperty.Value === false || marketProperty.Value === true) {
        return 'true / false'
      }
      return this.getFormattedValue(marketProperty)
    },
    getFormattedValue (marketProperty) {
      if (this.HasValue(marketProperty.Value)) {
        let formattedValue = marketProperty.Value.toString()
        const indexOfDecimal = formattedValue.indexOf('.')
        if (indexOfDecimal > 0) {
          if (formattedValue.length == indexOfDecimal + 3) {
            formattedValue = parseFloat(formattedValue).toFixed(2).toString().substring(0, indexOfDecimal + 3)
          }
          if (formattedValue.length >= indexOfDecimal + 4) {
            formattedValue = parseFloat(formattedValue).toString().substring(0, indexOfDecimal + 4)
          }
        }

        if (marketProperty.Name.toLowerCase().endsWith('pct')) {
          formattedValue = `${formattedValue} %`
        }
        return formattedValue
      }
      return null
    },
    getFilteredFields (stateFeeTax) {
      const filteredFields = []
      if (stateFeeTax) {
        const objectFields = this.getArrayOfObjectFields(stateFeeTax)
        if (objectFields) {
          objectFields.forEach(x => {
            if (x.Name !== 'CalculateRegistrationFee' &&
                x.Name !== 'RegistrationFee') {
              filteredFields.push(x)
            }
          })
        }
      }
      return filteredFields
    },
    OnlyUnique (value, index, array) {
      return array.indexOf(value) === index
    },
    async filterVehicles () {
      if (!this.getResultsLoading &&
          !this.isFiltering) {
        this.isFiltering = true
        this.getResultsLoading = true

        var self = this
        let url = '/api/FilterVehicles?'

        if (this.state.selectedStockType === this.StockType.New) {
          url += 'isNew=true&'
        }

        if (this.state.selectedYear) {
          url += 'year=' + this.state.selectedYear + '&'
        }

        if (this.state.selectedModelId) {
          url += 'modelId=' + this.state.selectedModelId + '&'
        }

        if (this.state.selectedMakeId) {
          url += 'makeId=' + this.state.selectedMakeId + '&'
        }

        if (this.state.selectedVehicleId && this.state.selectedVehicleId !== '') {
          url += 'vehicleId=' + this.state.selectedVehicleId + '&'

          if (this.state.selectedRegion) {
            this.getRegistrationFeesParameters()
          }
        } else {
          this.state.parammeters = null
        }

        const response = await axios.get(url)

        try {
          self.defaults.makes = response.data.makes
          self.defaults.models = response.data.models
          self.defaults.vehicles = response.data.vehicles
          self.defaults.years = response.data.years

          self.defaults.vehicles.forEach(x => {
            x.ShortDescriptionModel = `${x.ShortDescription} - ${x.ModelNumber}`
          })

          if (self.defaults.makes.length === 1) {
            self.state.selectedMakeId = self.defaults.makes[0].ID
          }

          if (self.defaults.models.length === 1) {
            self.state.selectedModelId = self.defaults.models[0].ID
          }

          if (self.defaults.years.length === 1) {
            self.state.selectedYear = self.defaults.years[0]
          }

          if (self.defaults.vehicles.length === 1) {
            self.state.selectedVehicleId = self.defaults.vehicles[0].ID
          }
          if (self.hasError(response)) {
            self.handleError(response)
          }
        } catch (error) {
          self.handleException('An error occured during your request')
        }

        this.isFiltering = false
        this.getResultsLoading = false
      }
    },
    async getUserFilledData () {
      if (this.GetLocalStorageWithExpiration('customerZip') !== null) {
        this.state.zipCode = this.GetLocalStorageWithExpiration('customerZip')
      }

      if (this.GetLocalStorageWithExpiration('inventoryVehicleIsNew') !== null) {
        if (this.GetLocalStorageWithExpiration('inventoryVehicleIsNew') === 'true' || this.GetLocalStorageWithExpiration('inventoryVehicleIsNew') === true) {
          this.state.selectedStockType = this.StockType.New
        } else {
          this.state.selectedStockType = this.StockType.Used
        }
      }

      // const selectedMake = this.defaults.makes.find(t => t.ID === x.MakeID)
      // const selectedModel = this.defaults.models.find(t => t.ID === x.ModelID)

      if (this.GetLocalStorageWithExpiration('inventoryVehicleMake') !== null && this.defaults.makes !== null) {
        this.state.selectedMakeId = this.defaults.makes.find(t => t.Name === this.GetLocalStorageWithExpiration('inventoryVehicleMake')).ID
      }
      if (this.GetLocalStorageWithExpiration('inventoryVehicleModel') !== null && this.defaults.models !== null) {
        this.state.selectedModelId = this.defaults.models.find(t => t.Name === this.GetLocalStorageWithExpiration('inventoryVehicleModel')).ID
      }
      if (this.GetLocalStorageWithExpiration('inventoryVehicleYear') !== null) {
        this.state.selectedYear = parseInt(this.GetLocalStorageWithExpiration('inventoryVehicleYear'))
      }

      await this.filterVehicles()

      if (this.GetLocalStorageWithExpiration('inventoryVehicleTrim') !== null) {
        if (this.defaults.vehicles.find(t => t.ShortDescription === this.GetLocalStorageWithExpiration('inventoryVehicleTrim')) !== undefined) {
          this.state.selectedVehicleId = this.defaults.vehicles.find(t => t.ShortDescription === this.GetLocalStorageWithExpiration('inventoryVehicleTrim')).ID
          this.submitZipSearch(true, undefined)
        }
      }
    },
    /* Error handling */
    hasError (response) {
      if (this.isNullOrUndefined(response)) return false

      if (response.hasOwnProperty('ErrorType') && response.hasOwnProperty('Message')) { return true }

      return false
    },

    handleError (error) {
      if (error.ErrorType === ERROR_TYPE_SHOW) {
        console.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_TOAST) {
        return
      }

      if (error.ErrorType === ERROR_TYPE_CONSOLE) {
        return
      }

      console.error(error.Message)
    },

    handleException (error) {
      // console.log(error)
    },
    persist () {
      this.SetLocalStorage('customerZip', this.state.zipCode)
    }
  },

  computed: {
    showJsonRequest () {
      if (this.request) {
        return JSON.stringify(this.request, null, '\t')
      }
      return ''
    },
    showJsonTaxRequest () {
      if (this.requestTax) {
        return JSON.stringify(this.requestTax, null, '\t')
      }
      return ''
    },
    showJsonResponse () {
      if (this.response) {
        return JSON.stringify(this.response, null, '\t')
      }
      return ''
    },
    showJsonTaxResponse () {
      if (this.responseTax) {
        return JSON.stringify(this.responseTax, null, '\t')
      }
      return ''
    },
    parametersGrouped () {
      const parameters = []

      this.state.parameters.forEach(x => {
        let parameter = parameters.find(t => t.ModeType === x.ModeType)
        if (!parameter) {
          parameter = {
            ModeType: x.ModeType,
            Parameters: [],
            ModeTypeOrder: this.getModeTypeOrder(x.ModeType)
          }
          parameters.push(parameter)
        }

        parameter.Parameters.push(x)
      })

      return parameters.sort(function (a, b) { return a.ModeTypeOrder - b.ModeTypeOrder })
    },
    vehiclesGrouped () {
      let vehicles = []
      if (this.defaults.vehicles) {
        vehicles = this.defaults.vehicles

        vehicles.forEach(x => {
          const selectedMake = this.defaults.makes.find(t => t.ID === x.MakeID)
          const selectedModel = this.defaults.models.find(t => t.ID === x.ModelID)
          x.Group = x.Year + ' ' + selectedMake.Name + ' ' + selectedModel.Name
        })
      }
      return new DataSource({
        store: vehicles,
        key: 'ID',
        group: 'Group'
      })
    },
    marketFeePropertiesFiltered () {
      if (this.state.selectedRegion && this.state.selectedRegion.marketFeeProperties) {
        let properties = []

        this.state.selectedRegion.marketFeeProperties
          .filter(x => x.name.toLowerCase().endsWith('pct') || (x.__type === 'array' && x.value.filter(t => t.name.toLowerCase().endsWith('pct'))))
          .forEach(x => {
            if (x.__type !== 'array') {
              x.parentType = this.ParentType.Undefined
              properties.push(x)
            } else {
              x.value.forEach(t => {
                if (t.name.toLowerCase().endsWith('pct') || t.__type === 'array' && t.value.filter(r => r.name.toLowerCase().endsWith('pct'))) {
                  t.parentType = this.ParentType.Undefined

                  switch (x.name) {
                    case 'Lease':
                      t.parentType += this.ParentType.Lease
                      break
                    case 'Retail':
                      t.parentType += this.ParentType.Retail
                      break
                  }
                  properties.push(t)
                }
              })
            }
          })

        let propertiesUndup = []
        properties.forEach(x => {
          let existingProperty = propertiesUndup.find(t => t.name === x.name)

          if (existingProperty) {
            existingProperty.parentType += x.parentType
          } else {
            propertiesUndup.push(x)
          }
        })

        properties = []

        propertiesUndup.forEach(x => {
          let property = properties.find(t => t.ParentType === x.parentType)
          if (!property) {
            property = {
              ParentType: x.parentType,
              Properties: [],
              ParentTypeOrder: this.getParentTypeOrder(x.parentType)
            }
            properties.push(property)
          }

          property.Properties.push(x)
        })

        return properties.sort(function (a, b) { return a.ParentTypeOrder - b.ParentTypeOrder })
      }
      return []
    },
    isShowingResultsButton () {
      return this.state.selectedVehicleId &&
          this.state.zipCode &&
          this.state.selectedRegionCountyId &&
          this.state.parameters &&
          this.state.parameters.filter(x => x.Requirement === this.RequirementType.Required && (x.Value === undefined ||
            x.Value === null ||
            x.Value === '')).length == 0
    },
    areLeaseAndRetailFeesTheSame () {
      if (!this.response ||
          !this.response.Retail ||
          !this.response.Lease) {
        return false
      }

      for (let i = 0; i < this.response.Retail.RegistrationItem.length; i++) {
        if (this.response.Lease.RegistrationItem.filter(x => x.Description === this.response.Retail.RegistrationItem[i].Description &&
            x.Value === this.response.Retail.RegistrationItem[i].Value).length !== 1) {
          return false
        }
      }

      for (let i = 0; i < this.response.Lease.RegistrationItem.length; i++) {
        if (this.response.Retail.RegistrationItem.filter(x => x.Description === this.response.Lease.RegistrationItem[i].Description &&
            x.Value === this.response.Lease.RegistrationItem[i].Value).length !== 1) {
          return false
        }
      }

      return true
    },
    dmvFeesRequiresHr () {
      if (this.state.selectedRegion && this.state.selectedRegion.marketFeeProperties) {
        return this.state.selectedRegion.marketFeeProperties.filter(x => x.ParentType === this.ParentType.Undefined).length > 0
      }

      return false
    }
  }

}
</script>

<style>
  .max-width > button,
  .max-width {
    width: 100%;
  }

  .text-right {
    text-align: right;
  }

  .no-padding-right {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .no-padding-left {
    padding-left: 0px !important;
  }

  .center-content {
     display:flex;
     align-items:center;
  }
  .btn-calculate {
    background-color: #0C823D !important;
    color: white !important;
    font-size: 1rem !important;
    border-radius: 3px !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px !important;
  }
  .card {
    border-radius: 3px !important;
    box-shadow: rgba(0,0,0,0.1) 0px 4px 6px -1px, rgba(0,0,0,0.06) 0px 2px 4px -1px;
  }
  .card-dropdown {
    border-radius: 3px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/DMVFees.vue